module.exports = __webpack_public_path__ + "static/media/Tusimice.e5563a93.png";